<template>
  <div class="featured mrow" :class="styleClass">
    <div class="mcol">
      <div :class="styleClass === 'large-style' ? 'h2' : 'h3'">
        <slot name="featured-title">some Title </slot>
      </div>
    </div>
    <div class="mcol">
      <slot name="default"> </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "featured",

  props: {
    kind: {
      type: String
    }
  },
  computed: {
    styleClass() {
      return this.kind === "lg" ? "large-style" : "small-style";
    }
  }
};
</script>

<style lang="scss">

@import "../scss/_typography.scss";
.featured {


  ul {
    margin: 1.5rem 0;
    list-style-type: none;
    li {
      margin: 1rem 0;
    }
  }

  &.large-style {
    .featured-title {
      @extend .h2;
    }
    ul {
      @include breakpoint(sm) {
        margin: 4.5rem 0 1.5rem;
      }
    }

    li {
      font-size: 1.25rem;
    }
  }
  &.small-style {
    .featured-title {
      @extend .h3;
    }
    ul {
      @include breakpoint(sm) {
        margin: 4.5rem 0 1.5rem;
      }
    }

    li {
      font-size: 1.25rem;
    }
  }
}


</style>
